module.exports = __webpack_public_path__ + "static/pushbikes-logo-a559602f5f17e92493aaafd07b036217.jpg";